module.exports = __webpack_public_path__ + "img/calendar.bcfcb746.svg";